import { ENDPOINTS, connectWithHammock } from 'hammock';
import React from 'react';

import { TemplateCard } from './TemplateCard';
import { TemplateMetadata } from './types';

interface Props {
  onSelectTemplate: () => void;
  template: TemplateMetadata;
}

const TemplateCardById = ({ template, onSelectTemplate }: Props) => {
  return <TemplateCard onClick={onSelectTemplate} template={template} />;
};

export default connectWithHammock(({ templateId }) => ({
  resourceName: 'template',
  endpoint: ENDPOINTS.templateMetadata,
  id: templateId,
}))(TemplateCardById);
